import React, { memo, useEffect, useState } from 'react'
import SummaryComponent from './Summaries/SummaryComponent/SummaryComponent'
import './Summary.scss'
import {getAvailableSummary, getSummaryReportByEntity} from 'actions/applicants'
import SosComingSoon from './Summaries/Components/SosComingSoon/SosComingSoon'
import { processStarted } from 'constants/utilityFunctions'
import ReportDrawer from './Summaries/SummaryDrawers/ReportDrawer'
import { Typography, Box } from '@material-ui/core'
import request from "../../../../../tools/request";

const Summary = memo(function Summary({ applicantId, anonymize, updates, changeTab, isGetAllData,
                                          handleGetAllData, updateSummaryCard, setDisplayGAD, setNotRunCount = () => {},
                                          getRetrieveDocuments, getFilingReportsAttachments, dispatchProcessing,
                                          sosSearchEnabled, debtorApplication, getAllReportAvailable, businessDisclosures, 
                                          isBrokerCustomer, creditCosts, creditUsageEnabled, isReadOnly = false,
                                          hideUpdateButtons = false, hideGetDataButtons = false,
                                          getAvailableSummaryFn = null, getSummaryReportByEntityFn = null,
                                          availableSummaryData = null, getBusinessReportSummaryFn = null,
                                          getOwnerReportSummaryFn = null }) { // Add prop for pre-loaded data

    const summaryTabChange = (tabNumber) => changeTab(null, tabNumber);
    const [reportsAvailable, setReportsAvailable] = useState([])

    const [openDrawer, setOpenDrawer] = useState(false);
    const [infoForReportDrawer, setInfoForReportDrawer] = useState({});
    const [disclosureData, setDisclosureData] = useState({});



    // Business & Legal Disclosures data
    useEffect(() =>{
        if(businessDisclosures && applicantId){
       const apiEndpoint = getAvailableSummaryFn ? 
           `marketplace/applications/${applicantId}/business-disclosure` : 
           `applications/${applicantId}/business-disclosure`;
       request(apiEndpoint, 'GET',null,false).then((res) => {
            const disclosureInfo = res || {};
            setDisclosureData(disclosureInfo);
        }).catch((err) => {
            console.error('Error fetching business and legal disclosures:', err);
        });
        }
    },[businessDisclosures, applicantId, getAvailableSummaryFn])

    // Map the disclosure data to display format
    const mappedBusinessDisclosures = [
        {
            question: "Are they current in the payment of your federal and state taxes?",
            answer: disclosureData?.currentOnTaxes === null ? "No answer provided" : (disclosureData?.currentOnTaxes ? "Yes" : "No"),
            description: disclosureData?.currentOnTaxesExplanation
        },
        {
            question: "Do they have any unsatisfied judgments or tax liens?",
            answer: disclosureData?.subjectToJudgments === null ? "No answer provided" : (disclosureData?.subjectToJudgments ? "Yes" : "No"),
            description: disclosureData?.subjectToJudgmentsExplanation
        },
        {
            question: "Are they currently being sued?",
            answer: disclosureData?.presentlyBeingSued === null ? "No answer provided" : (disclosureData?.presentlyBeingSued ? "Yes" : "No"),
            description: disclosureData?.presentlyBeingSuedExplanation
        },
        {
            question: "Are they current in the filing of all tax returns and reports?",
            answer: disclosureData?.currentOnTaxReturns === null ? "No answer provided" : (disclosureData?.currentOnTaxReturns ? "Yes" : "No"),
            description: disclosureData?.currentOnTaxReturnsExplanation
        }
    ];

    //useEffect to get available reports
    useEffect(() => {
        if (availableSummaryData) {
            const filteredReports = availableSummaryData.filter(item => item?.status?.value !== 'NOT_IMPLEMENTED') || [];
            setReportsAvailable(filteredReports)
            setDisplayGAD(!processStarted(filteredReports) && getAllReportAvailable)
            setNotRunCount(filteredReports.filter(item => item?.status?.value === 'NOT_DONE').length)
            return;
        }
        
        const availableSummaryFunction = getAvailableSummaryFn || getAvailableSummary;
        
        if (typeof availableSummaryFunction !== 'function') {
            console.error('availableSummaryFunction is not a function:', typeof availableSummaryFunction);
            return;
        }
        
        const apiCall = availableSummaryFunction(applicantId);
        if (typeof apiCall !== 'function') {
            console.error('availableSummaryFunction did not return a function:', typeof apiCall);
            return;
        }
        
        apiCall()
            .then((res) => {
                const filteredReports = res.filter(item => item?.status?.value !== 'NOT_IMPLEMENTED') || [];
                setReportsAvailable(filteredReports)
                setDisplayGAD(!processStarted(filteredReports) && getAllReportAvailable)
                setNotRunCount(filteredReports.filter(item => item?.status?.value === 'NOT_DONE').length)
            })
            .catch((error) => {
                console.error('Error fetching available summary:', error);
            });
        // eslint-disable-next-line
    }, [applicantId, updates, getAvailableSummaryFn, availableSummaryData]);

    const showReportDrawer = (applicantId, entityId, type, entityType) => {
        // Use marketplace function if provided, otherwise use regular function
        const summaryReportFunction = getSummaryReportByEntityFn || getSummaryReportByEntity;
        
        if (typeof summaryReportFunction !== 'function') {
            console.error('summaryReportFunction is not a function:', typeof summaryReportFunction);
            return;
        }
        
        const apiCall = summaryReportFunction(applicantId, entityId, type);
        if (typeof apiCall !== 'function') {
            console.error('summaryReportFunction did not return a function:', typeof apiCall);
            return;
        }
        
        apiCall()
            .then((res) => {
                setInfoForReportDrawer({ data: res, reportType: type, entityType: entityType })
                setOpenDrawer(true)
            })
            .catch((error) => {
                console.error('Error fetching summary report:', error);
            });
    }

    return (
        <div className='m-3'>
       {businessDisclosures && (
         <> <hr/>
         <div className='business-disclosure'>
             <Box sx={{ mb: 3 }}>
                 <Typography variant="h6" component="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                     Business & Legal Disclosures
                 </Typography>
                 <Box>
                     {mappedBusinessDisclosures?.map((disclosure, index) => (
                         <Box key={index} sx={{ mb: index < mappedBusinessDisclosures.length - 1 ? 3 : 0 }}>
                             <Typography
                                 variant="body2"
                                 color="textSecondary"
                                 sx={{ mb: 0.5, fontSize: '0.875rem' }}
                             >
                                 {disclosure.question}
                             </Typography>
                             <Typography
                                 variant="body1"
                                 sx={{ fontWeight: 500, mb: disclosure.description ? 1 : 0 }}
                             >
                                 {disclosure.answer}
                             </Typography>
                             {disclosure.description && (
                                 <Typography
                                     variant="body1"
                                     sx={{ color: 'text.primary', lineHeight: 1.6 }}
                                 >
                                     {disclosure.description}
                                 </Typography>
                             )}
                         </Box>
                     ))}
                 </Box>
             </Box>
         </div>
         </>
       )}
            {!sosSearchEnabled && <SosComingSoon isBrokerCustomer={isBrokerCustomer} summaryTabChange={summaryTabChange}/>}
            {
                applicantId && (reportsAvailable?.length > 0) && (
                    reportsAvailable.map((report, index) => {
                        return (
                            <SummaryComponent
                                key={index}
                                summaryTabChange={summaryTabChange}
                                showReportDrawer={showReportDrawer}
                                report={report}
                                applicantId={applicantId}
                                handleGetAllData={handleGetAllData}
                                isGetAllData={isGetAllData}
                                updateSummaryCard={updateSummaryCard}
                                setDisplayGAD={setDisplayGAD}
                                getRetrieveDocuments={getRetrieveDocuments}
                                getFilingReportsAttachments={getFilingReportsAttachments}
                                dispatchProcessing={dispatchProcessing}
                                debtorApplication={debtorApplication}
                                creditCosts={creditCosts}
                                creditUsageEnabled={creditUsageEnabled}
                                isBrokerCustomer={isBrokerCustomer}
                                getBusinessReportSummaryFn={getBusinessReportSummaryFn}
                                getOwnerReportSummaryFn={getOwnerReportSummaryFn}
                                anonymize={anonymize}
                            />
                        )
                    }
                    )
                )
            }
            {
                openDrawer &&
                <ReportDrawer
                    onClose={() => setOpenDrawer(false)}
                    applicantId={applicantId}
                    info={infoForReportDrawer}
                />
            }
        </div>
    )
}
)

export default Summary